import { action } from "satcheljs";
import type MailListItemSelectionSource from "owa-mail-store/lib/store/schema/MailListItemSelectionSource";
import type { ActionSource } from "owa-mail-store";
export interface ON_SELECT_FOLDER_COMPLETEActionMessage {
    selectedFolderId: string;
    previousFolderId: string;
    isExitingSearch: boolean;
    selectedTableViewId: string;
    mailListItemSelectionSource: MailListItemSelectionSource;
    isInImmersiveView: boolean;
    actionSource: ActionSource;
    shouldFirstRowBeSelectedOnLoad: boolean;
}
export const onSelectFolderComplete: (selectedFolderId: string, previousFolderId: string, isExitingSearch: boolean, selectedTableViewId: string, mailListItemSelectionSource: MailListItemSelectionSource, isInImmersiveView: boolean, actionSource: ActionSource, shouldFirstRowBeSelectedOnLoad: boolean) => ON_SELECT_FOLDER_COMPLETEActionMessage = action("ON_SELECT_FOLDER_COMPLETE", (selectedFolderId: string, previousFolderId: string, isExitingSearch: boolean, selectedTableViewId: string, mailListItemSelectionSource: MailListItemSelectionSource, isInImmersiveView: boolean, actionSource: ActionSource, shouldFirstRowBeSelectedOnLoad: boolean): ON_SELECT_FOLDER_COMPLETEActionMessage => ({
    selectedFolderId,
    previousFolderId,
    isExitingSearch,
    selectedTableViewId,
    mailListItemSelectionSource,
    isInImmersiveView,
    actionSource,
    shouldFirstRowBeSelectedOnLoad,
}));
